import { getTableColumns } from 'helpers';

const TreatmentAssignColumns = [
  ['trtAsgnmtCode', 'string', 'Treatment Arm Code', 'left', true],
  ['description', 'string', 'Description', 'left', true],
  ['groupTrtAssignmtCd', 'string', 'Group Treatment Arm Code', 'left', true]
];

export default getTableColumns(TreatmentAssignColumns);
